/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton, Box, Flex } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Formik, Form } from 'formik';
import { useMemo } from 'react';
import TextAreaFormField from '../../../components/form/TextAreaFormField';
import c from '../../../constant';
import * as Yup from 'yup';

function Create({ step = null, onClose = () => null, onComplete = () => null }) {
	const { t } = useTranslation();

	const validationSchema = useMemo(
		() =>
			Yup.object().shape({
				comments: Yup.string().required('required'),
			}),
		[]
	);

	return (
		<Modal size="xl" closeOnEsc={true} closeOnOverlayClick={true} isOpen={true} onClose={onClose}>
			<ModalOverlay />
			<ModalContent borderRadius={c.borderRadius}>
				<ModalHeader pb={0} mb={0}>
					{t('Comments')}
				</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					<Formik
						initialValues={{ comments: '' }}
						validationSchema={validationSchema}
						onSubmit={(values) => {
							onClose();
							onComplete({ step, comments: values?.comments });
						}}
					>
						{({ values }) => (
							<Form>
								<Box mt="2">
									<TextAreaFormField name="comments" label={null} required={false} />
									<Flex flex="1" mt="6" mb={2} justifyContent="flex-end" alignItems="center">
										<Button type="submit" isLoading={false} borderRadius={c.borderRadius} colorScheme="blue" onMouseDown={() => null}>
											{t('Submit')}
										</Button>
									</Flex>
								</Box>
							</Form>
						)}
					</Formik>
				</ModalBody>
			</ModalContent>
		</Modal>
	);
}

export default Create;
